import { api_url } from "../../utils/constants";
const axios = require('axios').default;

export const downloadRequests = (requestStatus, pageNumber, pageSize,) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        const params = {
            'requestStatus': requestStatus,
            'pageNumber': pageNumber,
            'pageSize': pageSize,
        };

        axios({
            method: "GET",
            url: api_url + "/DownloadRequests",
            params: params,
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer ' + jwtToken },
        })
            .then(
                (response) => {
                    resolve(response.data);
                }, (error) => {
                    console.log(error);
                    reject(error);
                }
            )
    });
}

export const getRequestByRequestIdInt = (requestIdInt) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        axios({
            method: "GET",
            url: api_url + "/GetRequestByRequestIdInt",
            params: { 'requestIdInt': requestIdInt },
            headers: { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
            .then(
                (response) => {
                    resolve(response.data);
                }, (error) => {
                    console.log(error);
                    reject(error);
                }
            )
    });
}

export const downloadMyLatestRequest = (userId) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        let fdd = new FormData();
        fdd.append('userId', userId);

        axios({
            method: "POST",
            url: api_url + "/DownloadMyLatestRequest",
            data: fdd,
            headers: { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
            .then(
                (response) => {
                    resolve(response.data);
                }, (error) => {
                    console.log(error);
                    reject(error);
                }
            )
    });
}


export const downloadPeopleRequest = (userId, category, incrementSizePeopleRequest, lowerLimitPeopleRequest, userCountry, userLat, userLng, distanceUnit, range) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        const params = {
            'userId': userId,
            'category': category,
            'upperLimit': incrementSizePeopleRequest,
            'lowerLimit': lowerLimitPeopleRequest,
            'userCountry': userCountry,
            'userLat': userLat,
            'userLng': userLng,
            'distanceUnit': distanceUnit,
            'range': range,
        }

        axios({
            method: "GET",
            url: api_url + "/DownloadPeopleRequest",
            params: params,
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer ' + jwtToken },
        })
            .then(
                (response) => {
                    resolve(response.data);
                }, (error) => {
                    console.log(error);
                    reject(error);
                }
            )
    });
}

export const uploadRequest = (
    requestType,
    requestDescription,
    requestCriteria,
    businessType,
    countryName,
    currencyCd,
    serviceDate,
    startTime,
    endTime,
    isMediaPresent
) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        const data = {
            requestType,
            requestDescription,
            businessType,
            countryName,
            currencyCd,
            serviceDateS: serviceDate,
            startTime,
            endTime,
            isMediaPresent,
            requestCriteria, // Already a JS object/array, no need to stringify
        };

        axios({
            method: "POST",
            url: api_url + "/UploadRequest",
            data: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + jwtToken,
            },
        })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                console.error(error);
                reject(error);
            });
    });
};

export const uploadRequestWithServiceItems = (
    requestUserId,
    unitsCount,
    totalCost,
    requestType,
    requestDescription,
    businessType,
    countryName,
    currencyCd,
    criteriaList,
    itemsList,
    serviceDateS,
    startTime,
    endTime,
    platformFeePercent,
    isPrePaymentNeeded,
    isOnBehalfRequest
) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        const data = {
            requestUserId,
            unitsCount,
            totalCost,
            requestType,
            requestDescription,
            businessType,
            countryName,
            currencyCd,
            criteriaList,           // already an object/array
            itemsList,              // already an object/array
            serviceDateS,
            startTime,
            endTime,
            platformFeePercent,
            isPrePaymentNeeded,
            isOnBehalfRequest
        };

        axios({
            method: "POST",
            url: api_url + "/UploadRequestWithServiceItems",
            data: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + jwtToken
            }
        })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                console.error(error);
                reject(error);
            });
    });
};

export const uploadRequestMedia = (userId, requestIdInt, mediaType, file) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        let fdd = new FormData();
        fdd.append('userId', userId);
        fdd.append('requestIdInt', requestIdInt);
        fdd.append('mediaType', mediaType);
        fdd.append('file', file);

        axios({
            method: "POST",
            url: api_url + "/UploadRequestMedia",
            data: fdd,
            headers: { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
            .then(
                (response) => {
                    resolve(response.data);
                }, (error) => {
                    console.log(error);
                    reject(error);
                }
            )
    });
}

export const createRequest = (
    requestType,
    requestDescription,
    businessType,
    countryName,
    currencyCd,
    serviceDate,
    startTime,
    endTime,
    isMediaPresent,
    requestCriteria,
    userId
) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        const data = {
            requestType,
            requestDescription,
            businessType,
            countryName,
            currencyCd,
            serviceDateS: serviceDate,
            startTime,
            endTime,
            isMediaPresent,
            requestCriteria, // Already a JS object/array, no need to stringify
            userId
        };

        axios({
            method: "POST",
            url: api_url + "/CreateRequest",
            data: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + jwtToken,
            },
        })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                console.error(error);
                reject(error);
            });
    });
};

export const createRequestByUser = (payload) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        axios({
            method: "POST",
            url: api_url + "/CreateRequestByUser",
            data: JSON.stringify(payload),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + jwtToken,
            },
        })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                console.error(error);
                reject(error);
            });
    });
};

export const getRequestDetails = (requestIdInt) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        var fdd = new FormData();
        fdd.append('requestIdInt', requestIdInt);

        axios({
            method: "POST",
            url: api_url + "/GetRequestDetails",
            data: fdd,
            headers: { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
            .then(
                (response) => {
                    resolve(response.data);
                }, (error) => {
                    console.log(error);
                    reject(error);
                }
            )
    });
}

export const getTeamRequestDetails = (spUserId, requestIdInt, teamId) => {
    return new Promise((resolve, reject) => {
        axios({
            method: "GET",
            url: api_url + "/public/GetTeamRequestDetails",
            params: { 'spUserId': spUserId, 'requestIdInt': requestIdInt, 'teamId': teamId },
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then(
                (response) => {
                    resolve(response.data);
                }, (error) => {
                    console.log(error);
                    reject(error);
                }
            )
    });
}

export const getSharedJobRequestDetails = (spUserId, requestIdInt, jobTokenId) => {
    return new Promise((resolve, reject) => {
        axios({
            method: "GET",
            url: api_url + "/public/GetSharedJobRequestDetails",
            params: { 'spUserId': spUserId, 'requestIdInt': requestIdInt, 'jobTokenId': jobTokenId },
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then(
                (response) => {
                    resolve(response.data);
                }, (error) => {
                    console.log(error);
                    reject(error);
                }
            )
    });
}

export const downloadCriteriaResponse = (requestIdInt, respondUserId) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        var fdd = new FormData();
        fdd.append('requestIdInt', requestIdInt);
        fdd.append('respondUserId', respondUserId);

        axios({
            method: "POST",
            url: api_url + "/DownloadCriteriaResponse",
            data: fdd,
            headers: { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
            .then(
                (response) => {
                    resolve(response.data);
                }, (error) => {
                    console.log(error);
                    reject(error);
                }
            )
    });
}

export const uploadResponse = (
    requestIdInt,
    respondUserId,
    respondUserFullNm,
    requestUserId,
    requestUserFullNm,
    requestDescription,
    respondMessage,
    criteriaResponse,
    matchPercent,
    newChipsAmount,
    chipValue,
    listingId,
    isPayAsYouGo
) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        let respondObj = {
            'requestIdInt': requestIdInt,
            'respondUserId': respondUserId,
            'respondUserFullNm': respondUserFullNm,
            'requestUserId': requestUserId,
            'requestUserFullNm': requestUserFullNm,
            'requestDescription': requestDescription,
            'respondMessage': respondMessage,
            'criteriaResponse': criteriaResponse,
            'matchPercent': matchPercent,
            'newChipsAmount': newChipsAmount,
            'chipValue': chipValue,
            'listingId': listingId,
            'isPayAsYouGo': isPayAsYouGo
        };

        axios({
            method: "POST",
            url: api_url + "/UploadResponse",
            data: respondObj,
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer ' + jwtToken },
        })
            .then(
                (response) => {
                    resolve(response.data);
                }, (error) => {
                    console.log(error);
                    reject(error);
                }
            )
    });
}

export const updateRequestStatus = (requestIdInt, requestStatus) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        var fdd = new FormData();
        fdd.append('requestIdInt', requestIdInt);
        fdd.append('requestStatus', requestStatus);

        axios({
            method: "POST",
            url: api_url + "/UpdateRequestStatus",
            data: fdd,
            headers: { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
            .then(
                (response) => {
                    resolve(response.data);
                }, (error) => {
                    console.log(error);
                    reject(error);
                }
            )
    });
}

export const getResponseByRequestIdIntAndRespondUserId = (requestIdInt) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        axios({
            method: "GET",
            url: api_url + "/GetResponseByRequestIdIntAndRespondUserId",
            params: { 'requestIdInt': requestIdInt },
            headers: { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
            .then(
                (response) => {
                    resolve(response.data);
                }, (error) => {
                    console.log(error);
                    reject(error);
                }
            )
    });
}

export const confirmCustomerDetails = (requestIdInt, message, serviceAddress) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        let fdd = new FormData();
        fdd.append('requestIdInt', requestIdInt);
        fdd.append('message', message);
        fdd.append('serviceAddress', serviceAddress)

        axios({
            method: "POST",
            url: api_url + "/ConfirmCustomerDetails",
            data: fdd,
            headers: { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
            .then(
                (response) => {
                    resolve(response.data);
                }, (error) => {
                    console.log(error);
                    reject(error);
                }
            )
    });
}